// Pronouns, and what the question writer is told about them.
//
// Season 0 misgendered a real member: nothing told the generator anything about
// gender, so it inferred one from the spelling of a name. Small bug, outsized
// cost, because it lands in front of the whole crew inside a game whose entire
// point is showing you pay attention.

export type Pronouns = "he/him" | "she/her" | "they/them";

export const PRONOUN_CHOICES: { value: Pronouns; label: string }[] = [
  { value: "he/him", label: "he/him" },
  { value: "she/her", label: "she/her" },
  { value: "they/them", label: "they/them" },
];

// The line handed to the generator about one person.
//
// A blank is an instruction, not an omission. Left to its own devices the model
// guesses from the name, which is exactly the failure; told to use the name
// instead, it writes around the problem entirely. So somebody who skipped and
// somebody who would rather not say both get the same safe treatment, and
// neither has to explain themselves to get it.
export function pronounInstruction(name: string, pronouns: string | null | undefined): string {
  const p = (pronouns ?? "").trim();
  if (p === "he/him" || p === "she/her" || p === "they/them") {
    return `${name} uses ${p} pronouns.`;
  }
  return `${name} has not said which pronouns to use, so use "${name}" rather than any pronoun, and never guess from the name.`;
}

// The same for a whole crew, for prompts that mention more than one person.
export function crewPronounNotes(
  people: { name: string; pronouns?: string | null }[]
): string {
  if (people.length === 0) return "";
  return people.map((p) => pronounInstruction(p.name, p.pronouns)).join(" ");
}

export function isValidPronouns(v: unknown): v is Pronouns {
  return v === "he/him" || v === "she/her" || v === "they/them";
}
